<template>
  <Teleport :disabled="mountTo === null" :to="mountTo">
    <div
      class="z-50 fixed inset-0 flex pt-safe-area-top"
      :class="[
        backdropOverrideClass ?? ['md:bg-black/50', mobileFullscreen ? 'bg-white' : 'bg-black/50'],
      ]"
      role="dialog"
      aria-modal="true"
      @click="onBackdropClick"
    >
      <Transition
        :enter-active-class="
          'transition ' + (mobileFullscreen ? 'duration-0 md:duration-300' : 'duration-300')
        "
        :leave-active-class="
          'transition ' + (mobileFullscreen ? 'duration-0 md:duration-300' : 'duration-300')
        "
        enter-from-class="translate-y-full md:translate-y-10 opacity-0"
        leave-to-class="translate-y-full md:translate-y-10 opacity-0"
        appear
        @after-leave="$emit('close')"
      >
        <div
          v-if="showModal"
          class="flex w-full md:overflow-y-auto h-full md:h-full md:px-4 md:py-12"
          :class="mobileFullscreen ? 'h-full' : 'pt-10'"
        >
          <div
            class="max-h-full md:max-h-none pb-safe-area-bottom relative flex flex-col bg-white w-full md:m-auto md:rounded-6"
            :class="[modalClass, mobileFullscreen ? '' : 'mt-auto rounded-t-16']"
            @click.stop
          >
            <button
              v-if="canBeDismissed"
              class="z-10 p-2 absolute right-2 top-2 md:-top-10 outline-none"
              @click="showModal = false"
            >
              <svg role="presentation" focusable="false" tabindex="-1" class="icon icon-sm md:text-white"
                 
                alt="close"
                svg-inline
               xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32"><title>close</title>
  <path fill="currentColor" d="M24.63 3.06a3.05 3.05 0 1 1 4.31 4.3L7.37 28.95a3.05 3.05 0 0 1-4.31-4.3L24.63 3.05Z"/>
  <path fill="currentColor" d="M28.94 24.63a3.05 3.05 0 0 1-4.3 4.31L3.05 7.37a3.05 3.05 0 1 1 4.3-4.31l21.58 21.57Z"/>
</svg>
            </button>
            <div class="overflow-y-auto md:overflow-y-visible" :class="innerClass">
              <slot />
            </div>
          </div>
        </div>
      </Transition>
    </div>
  </Teleport>
</template>

<script lang="ts" setup>
defineEmits(['close'])

const props = withDefaults(
  defineProps<{
    mountTo?: string | null
    modalClass?: string | Record<string, boolean>
    innerClass?: string | Record<string, boolean>
    canBeDismissed?: boolean
    mobileFullscreen?: boolean
    backdropOverrideClass?: string
  }>(),
  { mountTo: 'body', canBeDismissed: true },
)

onMounted(() => {
  if (props.mountTo) {
    document.body.classList.add('overflow-hidden')
    document.addEventListener('keydown', onEscape)
  }
})

onBeforeUnmount(() => {
  if (props.mountTo) {
    document.body.classList.remove('overflow-hidden')
    document.removeEventListener('keydown', onEscape)
  }
})

const showModal = ref(true)

function onEscape(e: KeyboardEvent) {
  if (e.key === 'Escape' && props.canBeDismissed) {
    showModal.value = false
  }
}

function onBackdropClick() {
  if (props.mobileFullscreen && document.body.clientWidth < 768) {
    return
  }
  if (props.canBeDismissed) {
    showModal.value = false
  }
}
</script>
